<template>
  <div class="cs">

    <!-- Hero banner -->
    <section class="cs__hero">
      <img
        src="https://songhancapital.com/assets/image/banner5.jpg"
        alt="University Banner"
        class="cs__hero-img"
      />
    </section>

    <main class="cs__main">
      <div class="cs__shell">

        <!-- Article -->
        <article class="cs__article cs__fade">

          <!-- Meta -->
          <div class="cs__meta">
            <span class="cs__meta-tag cs__meta-tag--blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              26/11/2024
            </span>
            <span class="cs__meta-tag cs__meta-tag--green">{{ $t('blog.blog1.event') }}</span>
          </div>

          <!-- Text -->
          <p class="cs__para">
            {{ $t('blog.blog1.eventDes1') }}
            <strong>{{ $t('blog.blog1.eventDes2') }}</strong>.
          </p>
          <p class="cs__para">{{ $t('blog.blog1.eventDes3') }}</p>

          <!-- Gallery -->
          <div class="cs__gallery">
            <div class="cs__gallery-item" @click="openImageModal('https://songhancapital.com/assets/image/thumoi.jpg')">
              <img src="https://songhancapital.com/assets/image/thumoi.jpg" alt="Thư mời sự kiện" class="cs__gallery-img" />
            </div>
            <div class="cs__gallery-item" @click="openImageModal('https://songhancapital.com/assets/image/ketnoi.jpg')">
              <img src="https://songhancapital.com/assets/image/ketnoi.jpg" alt="Kết nối sinh viên" class="cs__gallery-img" />
            </div>
          </div>

          <!-- Objectives -->
          <div class="cs__section cs__section--blue">
            <h3 class="cs__section-title">🔹 {{ $t('blog.blog1.target') }}</h3>
            <ul class="cs__list">
              <li>{{ $t('blog.blog1.targetDes1') }}</li>
              <li>{{ $t('blog.blog1.targetDes2') }}</li>
              <li>{{ $t('blog.blog1.targetDes3') }}</li>
            </ul>
          </div>

          <!-- Activities -->
          <div class="cs__section cs__section--green">
            <h3 class="cs__section-title">🔹 {{ $t('blog.blog1.activity') }}</h3>
            <div class="cs__activity-grid">
              <div class="cs__activity-card">
                <span>💼</span>
                <p>{{ $t('blog.blog1.activityDes1') }}</p>
              </div>
              <div class="cs__activity-card">
                <span>🌟</span>
                <p>{{ $t('blog.blog1.activityDes2') }}</p>
              </div>
              <div class="cs__activity-card">
                <span>❓</span>
                <p>{{ $t('blog.blog1.activityDes3') }}</p>
              </div>
            </div>
          </div>

          <!-- Meaning -->
          <div class="cs__section cs__section--purple">
            <h3 class="cs__section-title">🔹 {{ $t('blog.blog1.meaning') }}</h3>
            <p class="cs__para cs__para--no-indent">{{ $t('blog.blog1.meaningDes1') }}</p>
          </div>

          <!-- Conclusion -->
          <div class="cs__conclusion">
            <span>👉</span>
            <p>{{ $t('blog.blog1.meaningDes2') }}</p>
          </div>

        </article>

        <!-- Contact CTA -->
        <div class="cs__cta cs__fade" @click="goToContact">
          <h3 class="cs__cta-title">{{ $t('contact.contactUs') }}</h3>
          <div class="cs__cta-grid">
            <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="cs__cta-btn cs__cta-btn--tg" @click.stop>
              <i class="fab fa-telegram-plane"></i>
              <div>
                <strong>{{ $t('common.telegram') }}</strong>
                <span>@SHC Rim</span>
              </div>
            </a>
            <a href="tel:+84766726416" class="cs__cta-btn cs__cta-btn--phone" @click.stop>
              <i class="fas fa-phone"></i>
              <div>
                <strong>{{ $t('common.telZaloViber') }}</strong>
                <span>+84.766.726.416</span>
              </div>
            </a>
          </div>
        </div>

        <!-- Product promo -->
        <div class="cs__promo cs__fade" @click="goToContact">
          <div class="cs__promo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
            </svg>
          </div>
          <div class="cs__promo-body">
            <h3 class="cs__promo-title">{{ $t('blog.blog1.product') }} ✨</h3>
            <p class="cs__promo-desc">{{ $t('blog.blog1.learn') }}</p>
            <div class="cs__promo-checks">
              <span><i class="fas fa-check"></i> {{ $t('common.safe') }}</span>
              <span><i class="fas fa-check"></i> {{ $t('common.profit') }}</span>
            </div>
          </div>
          <a href="/blog/dau-tu-an-toan-loi-nhuan-on-dinh-cung-ea-shc" class="cs__promo-btn" @click.stop>
            {{ $t('common.findOutNow') }}
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>

      </div>
    </main>

    <!-- Image modal -->
    <div v-if="showImageModal" class="cs__modal" @click="closeImageModal">
      <div class="cs__modal-box" @click.stop>
        <button class="cs__modal-close" @click="closeImageModal">
          <i class="fas fa-times"></i>
        </button>
        <img :src="selectedImage.src" :alt="selectedImage.alt" class="cs__modal-img" />
        <div class="cs__modal-caption">
          <p>{{ selectedImage.alt }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script src="./conect-student.js"></script>
<style src="./conect-student.scss" lang="scss"></style>
